/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_TitleInputs */

const en_blog_title = /** @type {(inputs: Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const es_blog_title = /** @type {(inputs: Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Blog_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const blog_title = /** @type {((inputs?: Blog_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_title(inputs)
	return es_blog_title(inputs)
});